var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-block" }, [
    _vm.showDefault
      ? _c(
          "div",
          [
            _vm._v("\n        Using default fees "),
            _vm.$userIsSuperAdmin()
              ? _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.setCustom.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("(customise)")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.modelData.text_array && _vm.modelData.text_array.length
              ? _vm._l(_vm.modelData.text_array, function(txt) {
                  return _c("div", [_vm._v(_vm._s(txt))])
                })
              : _vm._e()
          ],
          2
        )
      : _c(
          "div",
          [
            _vm.modelData
              ? [
                  _vm.user && _vm.$userIsSuperAdmin()
                    ? _c(
                        "a",
                        {
                          attrs: { href: "#!" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.setDefault.apply(null, arguments)
                            }
                          }
                        },
                        [_vm._v("(switch to default profile)")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-row user-block" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "col-md-6",
                          attrs: { label: "Shipping" }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "w-100",
                            class: {
                              "border bg-white": !_vm.$userIsSuperAdmin()
                            },
                            attrs: {
                              disabled: !_vm.$userIsSuperAdmin(),
                              type: "number",
                              id: _vm.getId("shipping")
                            },
                            model: {
                              value: _vm.modelData.shipping,
                              callback: function($$v) {
                                _vm.$set(_vm.modelData, "shipping", $$v)
                              },
                              expression: "modelData.shipping"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          staticClass: "col-md-6",
                          attrs: { label: "Shipping GST" }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "w-100",
                            class: {
                              "border bg-white": !_vm.$userIsSuperAdmin()
                            },
                            attrs: {
                              disabled: !_vm.$userIsSuperAdmin(),
                              type: "number",
                              id: _vm.getId("shipping_gst")
                            },
                            model: {
                              value: _vm.modelData.shipping_gst,
                              callback: function($$v) {
                                _vm.$set(_vm.modelData, "shipping_gst", $$v)
                              },
                              expression: "modelData.shipping_gst"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-row user-block" },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "col-md-6", attrs: { label: "Other" } },
                        [
                          _c("b-form-input", {
                            staticClass: "w-100",
                            class: {
                              "border bg-white": !_vm.$userIsSuperAdmin()
                            },
                            attrs: {
                              disabled: !_vm.$userIsSuperAdmin(),
                              type: "number",
                              id: _vm.getId("other")
                            },
                            model: {
                              value: _vm.modelData.other,
                              callback: function($$v) {
                                _vm.$set(_vm.modelData, "other", $$v)
                              },
                              expression: "modelData.other"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          staticClass: "col-md-6",
                          attrs: { label: "Brokerage" }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "w-100",
                            class: {
                              "border bg-white": !_vm.$userIsSuperAdmin()
                            },
                            attrs: {
                              disabled: !_vm.$userIsSuperAdmin(),
                              type: "number",
                              id: _vm.getId("brokerage")
                            },
                            model: {
                              value: _vm.modelData.brokerage,
                              callback: function($$v) {
                                _vm.$set(_vm.modelData, "brokerage", $$v)
                              },
                              expression: "modelData.brokerage"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.user
                    ? _c(
                        "div",
                        { staticClass: "form-row user-block" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "col-md-6",
                              attrs: { label: "Bunker" }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "w-100",
                                class: {
                                  "border bg-white": !_vm.$userIsSuperAdmin()
                                },
                                attrs: {
                                  disabled: !_vm.$userIsSuperAdmin(),
                                  type: "number",
                                  id: _vm.getId("bunker")
                                },
                                model: {
                                  value: _vm.modelData.bunker,
                                  callback: function($$v) {
                                    _vm.$set(_vm.modelData, "bunker", $$v)
                                  },
                                  expression: "modelData.bunker"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              staticClass: "col-md-6",
                              attrs: { label: "Stink Bug" }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "w-100",
                                class: {
                                  "border bg-white": !_vm.$userIsSuperAdmin()
                                },
                                attrs: {
                                  disabled: !_vm.$userIsSuperAdmin(),
                                  type: "number",
                                  id: _vm.getId("stink_bug")
                                },
                                model: {
                                  value: _vm.modelData.stink_bug,
                                  callback: function($$v) {
                                    _vm.$set(_vm.modelData, "stink_bug", $$v)
                                  },
                                  expression: "modelData.stink_bug"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-row agent-fees user-block" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "col-md-12",
                          attrs: { label: "Agent fees" }
                        },
                        [
                          _vm.modelData.agent_fees
                            ? [
                                _vm._l(_vm.modelData.agent_fees, function(
                                  agent_fee,
                                  index
                                ) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "row mb-3 align-items-center"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-2 col-sm-2" },
                                          [_vm._v(_vm._s(agent_fee.price_min))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-1 col-sm-1" },
                                          [_vm._v("-")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-4 col-sm-3" },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "w-100",
                                              class: {
                                                "border bg-white": !_vm.$userIsSuperAdmin()
                                              },
                                              attrs: {
                                                disabled: !_vm.$userIsSuperAdmin(),
                                                type: "number",
                                                placeholder: "max",
                                                state: _vm.rangeFieldState(
                                                  index
                                                ),
                                                id: _vm.getId(
                                                  "agent_fees" +
                                                    index +
                                                    "price_max"
                                                )
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.onMaxInput(
                                                    index,
                                                    $event
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.modelData.agent_fees[
                                                    index
                                                  ].price_max,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.modelData.agent_fees[
                                                      index
                                                    ],
                                                    "price_max",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "modelData.agent_fees[index].price_max"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-1 col-sm-1 text-center"
                                          },
                                          [_vm._v("=")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-4 col-sm-3" },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "w-100",
                                              class: {
                                                "border bg-white": !_vm.$userIsSuperAdmin()
                                              },
                                              attrs: {
                                                type: "number",
                                                placeholder: "fee",
                                                disabled: !_vm.$userIsSuperAdmin(),
                                                id: _vm.getId(
                                                  "agent_fees" + index + "fee"
                                                ),
                                                state:
                                                  _vm.modelData.agent_fees[
                                                    index
                                                  ].fee > 0
                                                    ? null
                                                    : false
                                              },
                                              on: { input: _vm.onInput },
                                              model: {
                                                value:
                                                  _vm.modelData.agent_fees[
                                                    index
                                                  ].fee,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.modelData.agent_fees[
                                                      index
                                                    ],
                                                    "fee",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "modelData.agent_fees[index].fee"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 col-sm-2 text-md-right"
                                          },
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                staticClass: "btn mt-2 mt-sm-0",
                                                attrs: {
                                                  disabled: !_vm.$userIsSuperAdmin()
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeAgentRow(
                                                      index
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "Remove\n                                    "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.rangeFieldState(index) === false
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "row align-items-center"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "alert alert-danger"
                                              },
                                              _vm._l(
                                                _vm.rangeFieldError(index),
                                                function(err) {
                                                  return _c("div", [
                                                    _vm._v("- " + _vm._s(err))
                                                  ])
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-btn",
                                  {
                                    staticClass: "btn mt-2 mt-sm-0",
                                    attrs: {
                                      disabled: !_vm.$userIsSuperAdmin()
                                    },
                                    on: { click: _vm.addAgentRow }
                                  },
                                  [
                                    _vm._v(
                                      "Add\n                            new row\n                        "
                                    )
                                  ]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-4",
                                  attrs: { label: "Increase agent fee by" }
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "w-100",
                                    class: {
                                      "border bg-white": !_vm.$userIsSuperAdmin()
                                    },
                                    attrs: {
                                      disabled: !_vm.$userIsSuperAdmin(),
                                      type: "number",
                                      id: _vm.getId("agent_fee_step_value")
                                    },
                                    on: { input: _vm.onInput },
                                    model: {
                                      value: _vm.modelData.agent_fee_step_value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.modelData,
                                          "agent_fee_step_value",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "modelData.agent_fee_step_value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-4",
                                  attrs: { label: "every" }
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "w-100",
                                    class: {
                                      "border bg-white": !_vm.$userIsSuperAdmin()
                                    },
                                    attrs: {
                                      disabled: !_vm.$userIsSuperAdmin(),
                                      type: "number",
                                      id: _vm.getId("agent_fee_step")
                                    },
                                    on: { input: _vm.onInput },
                                    model: {
                                      value: _vm.modelData.agent_fee_step,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.modelData,
                                          "agent_fee_step",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "modelData.agent_fee_step"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-4",
                                  attrs: { label: "yen for bids over" }
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "w-100",
                                    class: {
                                      "border bg-white": !_vm.$userIsSuperAdmin()
                                    },
                                    attrs: {
                                      disabled: !_vm.$userIsSuperAdmin(),
                                      type: "number",
                                      id: _vm.getId("agent_fee_step_after")
                                    },
                                    on: { input: _vm.onInput },
                                    model: {
                                      value: _vm.modelData.agent_fee_step_after,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.modelData,
                                          "agent_fee_step_after",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "modelData.agent_fee_step_after"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ]
              : _vm._e()
          ],
          2
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d26df36", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d26df36","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/User/Fees.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5d26df36","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/User/Fees.vue
// module chunks = 0